import { useState, useRef, useEffect } from "react";
// import "./AnnouncementPost.scss";
import IconButton from "../../../CommonComponents/IconButton";
import { getDataFromStorage } from "../../../../util";
import useCommonFunctionHooks from "../../../../Hooks/useCommonFunctionHooks";
import useAxiosPrivate from "../../../../Hooks/useAxiosPrivate";
import constants from "../../../../constants";
import { useContext } from "react";
import AlertContext from "../../../../context/AlertContext";
import useS3FileManagement from "../../../../Hooks/useS3FileManagement";
import Tooltip from "../../../CommonComponents/Tooltip";
import RichTextEditor from "../../../CommonComponents/RichTextEditor";
import Toast from "../../../CommonComponents/Toast";
import Modal from "../../../CommonComponents/Modal";
import Button from "../../../Button";
import ModalBody from "../../../CommonComponents/ModalBody";

// ─── Icons ────────────────────────────────────────────────────────────────────

const FileIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#344054"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
    <line x1="16" y1="13" x2="8" y2="13" />
    <line x1="16" y1="17" x2="8" y2="17" />
    <polyline points="10 9 9 9 8 9" />
  </svg>
);

const EditIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_5233_35406)">
      <path
        d="M9.16675 3.3332H3.33341C2.89139 3.3332 2.46746 3.50879 2.1549 3.82135C1.84234 4.13391 1.66675 4.55784 1.66675 4.99986V16.6665C1.66675 17.1086 1.84234 17.5325 2.1549 17.845C2.46746 18.1576 2.89139 18.3332 3.33341 18.3332H15.0001C15.4421 18.3332 15.866 18.1576 16.1786 17.845C16.4912 17.5325 16.6667 17.1086 16.6667 16.6665V10.8332M15.4167 2.0832C15.7483 1.75168 16.1979 1.56543 16.6667 1.56543C17.1356 1.56543 17.5852 1.75168 17.9167 2.0832C18.2483 2.41472 18.4345 2.86436 18.4345 3.3332C18.4345 3.80204 18.2483 4.25168 17.9167 4.5832L10.0001 12.4999L6.66675 13.3332L7.50008 9.99986L15.4167 2.0832Z"
        stroke="#344054"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_5233_35406">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const ThumbsUpIcon = ({ filled }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill={filled ? "#F96343" : "none"}
    stroke={filled ? "#F96343" : "#344054"}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3" />
  </svg>
);

const CommentIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="announcement-comment-icon"
  >
    <path
      d="M8 9.5H12M8 13H15M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 13.1971 3.23374 14.3397 3.65806 15.3845C3.73927 15.5845 3.77988 15.6845 3.798 15.7653C3.81572 15.8443 3.8222 15.9028 3.82221 15.9839C3.82222 16.0667 3.80718 16.1569 3.77711 16.3374L3.18413 19.8952C3.12203 20.2678 3.09098 20.4541 3.14876 20.5888C3.19933 20.7067 3.29328 20.8007 3.41118 20.8512C3.54589 20.909 3.73218 20.878 4.10476 20.8159L7.66265 20.2229C7.84309 20.1928 7.9333 20.1778 8.01613 20.1778C8.09715 20.1778 8.15566 20.1843 8.23472 20.202C8.31554 20.2201 8.41552 20.2607 8.61549 20.3419C9.6603 20.7663 10.8029 21 12 21Z"
      stroke="#344054"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const SendIcon = ({ onClick = null }) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    onClick={onClick}
    className="announcement-comment-send-icon"
  >
    <path
      d="M21 1L10 12M10 12L1 8L21 1L14 21L10 12Z"
      stroke="#344054"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// ─── Sub-components ───────────────────────────────────────────────────────────

const Avatar = ({ src, alt = "User Avatar", size = 64 }) => (
  <img
    className="avatar"
    src={
      src ??
      "https://static.vecteezy.com/system/resources/thumbnails/032/176/191/small_2x/business-avatar-profile-black-icon-man-of-user-symbol-in-trendy-flat-style-isolated-on-male-profile-people-diverse-face-for-social-network-or-web-vector.jpg"
    }
    alt={alt}
    referrerPolicy="no-referrer"
    style={{
      width: size,
      height: size,
      borderRadius: "50%",
      objectFit: "cover",
    }}
  />
);

const AttachmentChip = ({ name, attachment }) => {
  const { getPreSignedUrl } = useS3FileManagement();

  const openFile = async (file) => {
    if (file.hasOwnProperty("url")) {
      const preSignedData = await getPreSignedUrl(
        file.url,
        undefined,
        file.url.split(".").pop(),
        "GET",
      );
      console.log("presignedData:", preSignedData);
      window.open(preSignedData.url, "_blank");
    } else {
      const fileURL = URL.createObjectURL(file.file);
      window.open(fileURL, "_blank");
    }
  };
  return (
    <div className="attachment-chip" onClick={() => openFile(attachment)}>
      <FileIcon />
      <span className="attachment-chip__name">{name}</span>
    </div>
  );
};


const DownloadIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 12.5V15.8333C17 16.2754 16.8244 16.6993 16.5118 17.0118C16.1993 17.3244 15.7754 17.5 15.3333 17.5H4.66667C4.22464 17.5 3.80072 17.3244 3.48816 17.0118C3.17559 16.6993 3 16.2754 3 15.8333V12.5M6.33333 8.33333L10.5 12.5M10.5 12.5L14.6667 8.33333M10.5 12.5V2.5"
      stroke="#667085"
      strokeWidth="1.67"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const DeleteIconSvg = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.5 4.99996H4.16667M4.16667 4.99996H17.5M4.16667 4.99996V16.6666C4.16667 17.1087 4.34226 17.5326 4.65482 17.8451C4.96738 18.1577 5.39131 18.3333 5.83333 18.3333H14.1667C14.6087 18.3333 15.0326 18.1577 15.3452 17.8451C15.6577 17.5326 15.8333 17.1087 15.8333 16.6666V4.99996H4.16667ZM6.66667 4.99996V3.33329C6.66667 2.89127 6.84226 2.46734 7.15482 2.15478C7.46738 1.84222 7.89131 1.66663 8.33333 1.66663H11.6667C12.1087 1.66663 12.5326 1.84222 12.8452 2.15478C13.1577 2.46734 13.3333 2.89127 13.3333 3.33329V4.99996M8.33333 9.16663V14.1666M11.6667 9.16663V14.1666" stroke="#F04438" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
);

const CommentItem = ({ author, text, emoji, gradient, id, userId, setComments, setToastOpen, setToastMessage }) => {
  const { getCatchBlockDetails } = useCommonFunctionHooks();
  const axios = useAxiosPrivate();
  const [popUpOpen, setPopUpOpen] = useState(false);
  const deleteComment = async (id) => {
    try {
      console.log("button clicked", id);
      const response = await axios.delete(`/node/announcement/${id}/comment`);
      if (response.data.resultCode !== constants.RESULT_STATUS.SUCCESS) {
        throw new Error("Something went wrong");
      }
      setComments((prev) => prev.filter((c) => c.id !== id));
      setToastOpen(true);
      setToastMessage(response.data.msg);
    } catch (error) {
      getCatchBlockDetails(error);
    }
  }
  return (
    <div className="comment-item">
      <div className="comment-item-comment">
        <Avatar
          src={
            emoji ??
            "https://static.vecteezy.com/system/resources/thumbnails/032/176/191/small_2x/business-avatar-profile-black-icon-man-of-user-symbol-in-trendy-flat-style-isolated-on-male-profile-people-diverse-face-for-social-network-or-web-vector.jpg"
          }
          size={36}
        />
        <div className="comment-item__content">
          <span className="comment-item__author">{author}</span>
          <span className="comment-item__text">{text}</span>
        </div>
      </div>
      <div>
        {
          +userId === parseInt(getDataFromStorage("learnerid")) && (
            <IconButton
              size="sm"
              hierarchy="secondaryGrey"
              destructive={true}
              onClick={() => {
                setPopUpOpen(true);
              }}
            >
              <svg
                width="17"
                height="19"
                viewBox="0 0 17 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.834961 4.16836H2.50163M2.50163 4.16836H15.835M2.50163 4.16836V15.835C2.50163 16.277 2.67722 16.701 2.98978 17.0135C3.30234 17.3261 3.72627 17.5017 4.16829 17.5017H12.5016C12.9437 17.5017 13.3676 17.3261 13.6801 17.0135C13.9927 16.701 14.1683 16.277 14.1683 15.835V4.16836H2.50163ZM5.00163 4.16836V2.50169C5.00163 2.05966 5.17722 1.63574 5.48978 1.32318C5.80234 1.01062 6.22627 0.835022 6.66829 0.835022H10.0016C10.4437 0.835022 10.8676 1.01062 11.1801 1.32318C11.4927 1.63574 11.6683 2.05966 11.6683 2.50169V4.16836M6.66829 8.33502V13.335M10.0016 8.33502V13.335"
                  stroke="#B42318"
                  stroke-width="1.67"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </IconButton>
          )

        }

      </div>

      <Modal
        isOpen={popUpOpen}
        onClose={()=>setPopUpOpen(false)}
        showCloseIcon={false}
        className="library-topic-delete-modal"
      >
        <ModalBody
          content={
            <p style={{ textAlign: "center" }}>
              Are you sure you want to delete this <br />
              Comment?
            </p>
          }
          footer={
            <>
              <Button
                size="sm"
                hierarchy={{ type: "secondaryGrey", buttonText: "Cancel" }}
                onClick={() => setPopUpOpen(false)}
              />
              <Button
                size="sm"
                hierarchy={{
                  type: "primary",
                  buttonText: "Delete",
                }}
                onClick={()=>deleteComment(id)}
              // disable={!!errors.name}
              />
            </>
          }
        />
      </Modal>
    </div>
  )
};

// ─── Main AnnouncementPost Component ──────────────────────────────────────────

export default function AnnouncementPost({
  isAdmin = false,
  onEdit,
  authorName = "Gradious Admin",
  postedTo = "FSD Batch 1",
  timestamp = "12:12 PM, 12/03/2026",
  title = "Semester 1 Exams Timetable Released",
  description = "Semester 1 exams will start from 26 March 2026. The detailed timetable has been released, once go through it.",
  attachments = [],
  images = [],
  initialLikes = 0,
  initialComments = [],
  post = [],
}) {
  // Like state
  const [liked, setLiked] = useState(post.isLiked);
  const [likeCount, setLikeCount] = useState(initialLikes);

  // Comments state
  const [commentText, setCommentText] = useState("");
  const [comments, setComments] = useState(initialComments);
  const [showComments, setShowComments] = useState(false);
  const commentInputRef = useRef(null);

  // Carousel state
  const [currentImage, setCurrentImage] = useState(0);
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);

  const { getCatchBlockDetails } = useCommonFunctionHooks();
  const axios = useAxiosPrivate();
  const { getPreSignedUrl } = useS3FileManagement();
  const { setShowNotify, setIsLoaded } = useContext(AlertContext);

  const [toastOpen, setToastOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const[profilePic, setProfilePic] = useState(localStorage.getItem("picture"));
  useEffect(() => {
    const loadProfilePicture = async () => {
      let picture = localStorage.getItem("picture");

      if (!picture) {
        return;
      }

      try {
        const res = await getPreSignedUrl(
          [picture],
          undefined,
          "",
          "GET"
        );

        setProfilePic(res?.url?.[0] || picture);
      } catch (err) {
        console.log(err);

        setProfilePic(picture);
      }
    };

    loadProfilePicture();
  }, []);
  console.log("post.picture",post);
  // Auto‑focus the input when comments become visible
  useEffect(() => {
    if (showComments) {
      commentInputRef.current?.focus();
    }
  }, [showComments]);

  // ─── Like handlers ────────────────────────────
  const toggleLike = () => {
    // if (post.created_by !== parseInt(getDataFromStorage("learnerid"))) {
    updateLikeForPost(post.id);
    setLikeCount((prev) => (liked ? prev - 1 : prev + 1));
    setLiked((prev) => !prev);
    // }
  };

  // ─── Comment handlers ─────────────────────────
  const handleCommentButtonClick = () => {
    setShowComments((prev) => !prev);
  };

  const commentRegex = /[a-zA-Z0-9]/;

  const addNewComments = async (id) => {
    try {
      if (!commentText.trim() || !commentRegex.test(commentText)) {
        return;
      }
      setIsLoaded(true);
      const response = await axios.post(`/node/announcement/${id}/comment`, {
        content: commentText,
      });
      if (response.data.resultCode !== constants.RESULT_STATUS.SUCCESS) {
        throw new Error("Something went wrong");
      }
      setShowNotify({
        show: true,
        title: "Info",
        msg: response.data.msg,
      });
      let newComment = response.data.data;
      console.log("newComm:", newComment);

      setShowComments(true);
      setCommentText("");
      setComments((prev) => [newComment, ...prev]);
    } catch (error) {
      getCatchBlockDetails(error);
    } finally {
      setIsLoaded(false)
    }
  };

  const handleKeyDown = (e, id) => {
    if (e.key === "Enter") addNewComments(id);
  };

  // ─── Carousel handlers ────────────────────────
  const goToPrev = () => {
    setCurrentImage((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const goToNext = () => {
    setCurrentImage((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  const goToSlide = (index) => {
    setCurrentImage(index);
  };

  // Touch events for swipe support
  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = (e) => {
    touchEndX.current = e.changedTouches[0].clientX;
    const diff = touchStartX.current - touchEndX.current;
    if (Math.abs(diff) > 50) {
      if (diff > 0) goToNext();
      else goToPrev();
    }
  };

  const updateLikeForPost = async (id) => {
    try {
      const response = await axios.post(`/node/announcement/${id}/like`);
      console.log("response:", response);
      if (response.data.resultCode !== constants.RESULT_STATUS.SUCCESS) {
        throw new Error("Something went wrong");
      }
      setToastOpen(true);
      setToastMessage(response.data.msg);
    } catch (error) {
      getCatchBlockDetails(error);
    }
  };

  const downloadFile = async (file) => {

    if (file.hasOwnProperty("url")) {
      const preSignedData = await getPreSignedUrl(
        file.url,
        undefined,
        file.url.split(".").pop(),
        "GET"
      );

      const response = await fetch(preSignedData.url);
      const blob = await response.blob();

      const url = URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = file.url.split("/").pop() || "download";
      a.click();

      URL.revokeObjectURL(url);
    } else {
      try {
        const preSignedData = await getPreSignedUrl(
          file.key,
          undefined,
          file.key.split(".").pop(),
          "DOWNLOAD"
        );
        const response = await fetch(preSignedData.url);
        const blob = await response.blob();

        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = file.key.split("/").pop() || "download";
        a.click();

        URL.revokeObjectURL(url);
      } catch (err) {
        console.error("Download error:", err);
      }
    }
  };

  // console.log("attachemnets:", attachments);
  // console.log("images:", images);


  // ─── Render ──────────────────────────────────
  return (
    <div className="announcement-post">
      {/* Header */}
      <div className="announcement-post__header">
        <div className="author-info">
          <Avatar src={post.picture} size={64} />
          <div className="author-info__details">
            <div className="author-info__line">
              <span className="author-info__name">{authorName}</span>
              <span className="author-info__posted-to-label">posted to</span>
              <span className="author-info__posted-to-value">{postedTo}</span>
            </div>
            <span className="author-info__timestamp">{timestamp}</span>
          </div>
        </div>

        {isAdmin &&
          String(post.created_by) ===
          String(getDataFromStorage("learnerid")) && (
            <IconButton
              onClick={() => onEdit?.()}
              size="md"
              hierarchy="secondaryGrey"
              className="edit-button"
            >
              <EditIcon />
            </IconButton>
          )}
      </div>

      {/* Body */}
      <div className="announcement-post__body">
        <div className="announcement-post__title">{title}</div>

        {/* <div dangerouslySetInnerHTML={{ __html: description }} /> */}
        <RichTextEditor
          className="announcement-post-description"
          readOnly={true}
          value={description}
        />

        <div className="attachments-list">
          {attachments.length > 0 &&
            attachments.map((attachment) => (
              <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                <AttachmentChip
                  name={attachment.url.split("/").pop()}
                  attachment={attachment}
                  key={attachment.id}
                />
                {getDataFromStorage("role") === "learner" &&
                  attachment.isdownloadable === 1 &&
                  <div onClick={() => downloadFile(attachment)} style={{ cursor: "pointer" }}>
                    <DownloadIcon />
                  </div>}
              </div>
            ))}
        </div>
      </div>

      {/* ─── Carousel ──────────────────────────────────────────────────────── */}
      {images.length > 0 && (
        <div
          className="cover-image carousel"
          onTouchStart={handleTouchStart}
          onTouchEnd={handleTouchEnd}
        >
          <div
            className="carousel__track"
            style={{ transform: `translateX(-${currentImage * 100}%)` }}
          >
            {images.map((img, index) => {
              const url = typeof img === "string" ? img : img.url;
              const alt =
                typeof img === "object"
                  ? img.alt || `Image ${index + 1}`
                  : `Image ${index + 1}`;
              return (
                <div className="carousel__slide" key={index}>
                  {getDataFromStorage("role") === "learner" &&
                    img.isdownloadable === 1 &&
                    <div onClick={() => downloadFile({ preSignedUrl: img.url, key: img.key })} className="carousel_download">
                      <DownloadIcon />
                    </div>}
                  <img src={url} alt={alt} className="carousel__img" />
                </div>
              );
            })}
          </div>

          {images.length > 1 && (
            <>
              <button
                className="carousel__arrow carousel__arrow--left"
                onClick={goToPrev}
                aria-label="Previous image"
              >
                ‹
              </button>
              <button
                className="carousel__arrow carousel__arrow--right"
                onClick={goToNext}
                aria-label="Next image"
              >
                ›
              </button>
              <div className="carousel__dots">
                {images.map((_, index) => (
                  <button
                    key={index}
                    className={`carousel__dot ${index === currentImage ? "carousel__dot--active" : ""
                      }`}
                    onClick={() => goToSlide(index)}
                    aria-label={`Go to image ${index + 1}`}
                  />
                ))}
              </div>
            </>
          )}
        </div>
      )}

      {/* Footer */}
      <div className="announcement-post__footer">
        <div className="action-row">
          <div
            className={`like-section${liked ? " like-button--liked" : ""}`}
            onClick={toggleLike}
          >
            <ThumbsUpIcon filled={liked} />
            <span>Like</span>
          </div>
          {post.allowComments === 1 && (
            <div className="comment-section">
              <div className="comment-input-container">
                <div className="comment-input-wrapper">
                  <img
                    className="comment-adder-profile-image"
                    src={profilePic}
                    alt={getDataFromStorage("name")
                      .substring(0, 1)
                      .toUpperCase()}
                    width={36}
                    referrerPolicy="no-referrer"
                    height={36}
                  />
                  <input
                    ref={commentInputRef}
                    type="text"
                    value={commentText}
                    onChange={(e) => setCommentText(e.target.value)}
                    onKeyDown={(e) => handleKeyDown(e, post.id)}
                    placeholder="Comment your words here...."
                    className="comment-input"
                  />
                </div>
                <SendIcon onClick={() => addNewComments(post.id)} />
              </div>

              {/* Toggle comments visibility */}
              <div
                className="comment-toggle-btn-sec"
                onClick={handleCommentButtonClick}
              >
                {isAdmin ? (
                  <p className="comment-trigger">
                    {showComments ? "Hide" : "View"} Comments
                  </p>
                ) : null}
                <Tooltip
                  title={`${showComments ? "Hide" : "View"} Comments`}
                  isIcon={true}
                  theme="light"
                  placement="top"
                >
                  <CommentIcon />
                </Tooltip>
              </div>
            </div>
          )}
        </div>

        <span className="stats">
          {likeCount} Like{likeCount !== 1 ? "s" : ""}
        </span>

        {/* Comments section */}
        {showComments && (
          <>
            {console.log("comments:", comments)}
            {comments.length >= 1 && (
              <>
                <hr className="comments-divider" />
                <div className="comments-list">
                  {comments.map((c) => (
                    <CommentItem
                      key={c.id}
                      id={c.id}
                      author={c.author}
                      text={c.text}
                      emoji={c.picture}
                      gradient={c.gradient}
                      userId={c.userId}
                      setComments={setComments}
                      setToastMessage={setToastMessage}
                      setToastOpen={setToastOpen}
                    />
                  ))}
                </div>
              </>
            )}
            {comments.length === 0 && (
              <>
                <hr className="comments-divider" />
                <div className="no-comments">No comments yet. Be the first to comment!</div>
              </>
            )}
          </>
        )}
      </div>
      <Toast
        open={toastOpen}
        message={toastMessage}
        type="success"
        onClose={() => setToastOpen(false)}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      />
    </div>
  );
}
